<section class="content">
  <div class="container-fluid">
      <div class="block-header">
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <ul class="breadcrumb breadcrumb-style ">
                <li class="breadcrumb-item">
                  <h4 class="page-title">Basic Form</h4>
                </li>
                <li class="breadcrumb-item bcrumb-1">
                  <a routerLink="/dashboard/main">
                    <i class="fas fa-home"></i> Home</a>
                </li>
                <li class="breadcrumb-item bcrumb-2">
                  <a href="#" onClick="return false;">Forms</a>
                </li>
                <li class="breadcrumb-item active">Basic</li>
              </ul>
            </div>
          </div>
        </div>
    <app-maser-page-header></app-maser-page-header>
    <div class="row" style="max-width: 800px;    margin-top: 35px;">

      <div class="col-3">
        <mat-form-field class="form-line">
          <mat-label>Choose a date</mat-label>
          <input [ngModel]="default_date" style="border: none" #date matInput [matDatepicker]="picker">
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="col-3">
        <mat-form-field>
          <mat-label>Session</mat-label>
          <mat-select #session_id>
            <mat-option *ngFor="let session of sessions" [value]="session['id']">
              {{session['name']}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-3">
        <mat-form-field>
          <mat-label>Route</mat-label>
          <mat-select #route_id>
            <mat-option *ngFor="let route of routes[session_id.value]" [value]="route['id']">
              {{route['name']}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-3">
        <button mat-raised-button (click)="getGatePass(date.value, route_id.value, session_id.value)">Confirm</button>
      </div>
    </div>

    <hr>
    <!--    route details-->
    <div class="row" *ngIf="is_sales_data_available" style="max-width: 800px">
      <!--      left side-->
      <!--      super visor name-->
      <div class="col-6">
        <div class="row">
          <div class="col-3">Route Supervisor:</div>
          <div class="col-5">{{sales['route_supervisor']}}</div>
        </div>
        <!--      route name-->
        <div class="row">
          <div class="col-3">Route Name:</div>
          <div class="col-5">{{sales['route_name']}}</div>
        </div>
      </div>

      <!--      right side-->
      <div class="col-6">
        <!--        depature time -->
        <div class="row">
          <div class="col-3">Dept Time:</div>
          <div class="col-5"></div>
        </div>
        <!--        date-->
        <div class="row">
          <div class="col-3">Date:</div>
          <div class="col-5">{{sales['date'] | date: 'dd-MM-yyyy'}}</div>
        </div>

        <!--        vehicle number-->
        <div class="row">
          <div class="col-3">Vehicle No:</div>
          <div class="col-5">{{sales['vehicle_number']}}</div>
        </div>
      </div>
    </div>

    <table class="table table-hover " *ngIf="is_sales_data_available" style="max-width: 700px">
      <thead class="thead-dark">
        <tr>
          <th scope="col">S.No.</th>
          <th scope="col">Product</th>
          <th scope="col">Count</th>
          <th scope="col">Trays</th>
          <th scope="col">Pkts(+)</th>
          <th scope="col">Pkts(-)</th>
          <th scope="col">Leak Pkts</th>
          <th scope="col">Quantity</th>
        </tr>
      </thead>
      <tbody *ngIf="product_ids.length !== 0">
        <tr *ngFor="let product_id of milk_product_ids; let product_index=index">
          <th scope="row">{{product_index + 1}}</th>
          <td>{{sales['milk'][product_id]['product_short_name']}}</td>
          <td>{{sales['milk'][product_id]['count']}}</td>
          <td>{{sales['milk'][product_id]['calculated_tray_count']}}</td>
          <td>{{sales['milk'][product_id]['calculated_pocket_count']}}</td>
          <td>-{{sales['milk'][product_id]['calculated_pocket_count_in_negative']}}</td>
          <td>{{sales['milk'][product_id]['leak_packet']}}</td>
          <td>{{sales['milk'][product_id]['litre']}}</td>
        </tr>
        <tr>
          <th></th>
          <th>MILK TOTAL</th>
          <td>{{sales['total_milk_product_count']}}</td>
          <td>{{sales['total_milk_tray_count']}}</td>
          <td>{{sales['total_milk_packet_count']}}</td>
          <td>-{{sales['total_milk_packet_count_in_negative']}}</td>
          <td>{{sales['total_milk_leak_packet_count']}}</td>
          <td>{{sales['total_milk_litre_count']}}</td>
        </tr>
        <tr *ngFor="let product_id of other_product_ids; let product_index=index">
          <th scope="row">{{product_index + 1}}</th>
          <td>{{sales['other'][product_id]['product_short_name']}}</td>
          <td>{{sales['other'][product_id]['count']}}</td>
          <td>{{sales['other'][product_id]['calculated_tray_count']}}</td>
          <td>{{sales['other'][product_id]['calculated_pocket_count']}}</td>
          <td>-{{sales['other'][product_id]['calculated_pocket_count_in_negative']}}</td>
          <td>{{sales['other'][product_id]['leak_packet']}}</td>
          <td>{{sales['other'][product_id]['litre']}}</td>
        </tr>
        <tr>
          <th></th>
          <th>NET TOTAL</th>
          <td>{{sales['total_product_count']}}</td>
          <td>{{sales['total_tray_count']}}</td>
          <td>{{sales['total_packet_count']}}</td>
          <td>-{{sales['total_packet_count_in_negative']}}</td>
          <td>{{sales['total_leak_packet_count']}}</td>
          <td>{{sales['total_litre_count']}}</td>
        </tr>
      </tbody>
    </table>
<div *ngIf="pdf != null">
   <button (click)="showPdf()">download</button>
</div>
  </div>
</section>
